import { Button, Select } from "@components";
import { Drawer } from "@components/Drawer";
import { FlowAPI } from "@providers/FlowAPI";
import { useState } from "react";

import styles from "@styles/creatives-list.module.scss";

export const FlowExecutionReportDrawer = ({
  visible,
  flowId,
  stepId,
  globalReport,
  onClose,
}) => {
  const [selectedPeriod, setSelectedPeriod] = useState("yesterday");
  const [selectedType, setSelectedType] = useState("clicks");
  const [format, setFormat] = useState("csv");
  const [loading, setLoading] = useState(false);

  const makeReport = async () => {
    setLoading(true);
    await FlowAPI.generateFlowReport(flowId, globalReport ? null : stepId, {
      period: selectedPeriod,
      type: selectedType,
      format: format,
    });
    setLoading(false);
  };

  return (
    <Drawer
      visible={visible}
      closeInX
      closeInFade
      showCloseButton
      title={"Outros relatórios"}
      onClose={() => onClose()}
      footer={
        <Button
          text="Gerar"
          design="primary"
          className="w-100"
          loading={loading}
          disabled={loading}
          onClick={() => makeReport()}
        />
      }
    >
      <p className={styles.listTitle}>Selecione o relatório e o período</p>

      <Select
        title="Selecione o tipo"
        className="w-100"
        value={selectedType}
        options={[
          { label: "Envios", value: "sends" },
          { label: "Aberturas (somente e-mail)", value: "opens" },
          { label: "Cliques", value: "clicks" },
          { label: "Uso de cupons", value: "coupons" },
        ]}
        onChange={(e) => setSelectedType(e.target.value)}
      />
      <Select
        title="Selecione o periodo"
        className="mt-15 w-100"
        value={selectedPeriod}
        options={[
          { label: "Hoje", value: "today" },
          { label: "Ontem", value: "yesterday" },
          { label: "Ultimos 3 dias", value: "three_days" },
          { label: "Ultimos 7 dias", value: "seven_days" },
          { label: "Ultimo mês", value: "one_month" },
          { label: "Todo o período", value: "all" },
        ]}
        onChange={(e) => setSelectedPeriod(e.target.value)}
      />
    </Drawer>
  );
};
